import { Message } from 'element-ui'

export function pgMessage(options) {
  return Message({ offset: 100, ...options })
}

;['success', 'warning', 'info', 'error'].forEach((type) => {
  pgMessage[type] = (options) => {
    if (typeof options === 'string') {
      return pgMessage({ type, message: options })
    } else {
      return pgMessage({ type, ...options })
    }
  }
})

pgMessage.close = (...arg) => Message.close(...arg)
pgMessage.closeAll = () => Message.closeAll()
